<script>
import OmtIcons from "../Icons/index.vue";
import { CInput, CPseudoBox } from "@chakra-ui/vue";
import Vue from "vue";

/**
 * Input component based on https://vue.chakra-ui.com/input
 *
 * @prop {String} variant currently options : "outline", "unstyled", "flushed", "filled"
 * @prop {String} iconLeft any option included here src/components/Atoms/Icons/library.js
 * @prop {String} iconRight
 *
 */

export default Vue.component("OmtInput", {
  props: {
    variant: {
      type: String,
      default: "flushed",
      validator: value => ["outline", "unstyled", "flushed", "filled"].includes(value)
    },
    iconLeft: String,
    iconRight: String,
    iconRightColor: String,
    iconRightPrefix: String,
    iconLeftClick: Function,
    iconRightClick: Function,
    triggerIconRightOnPress: Boolean,
    fontSize: String,
    fontWeight: String,
    letterSpacing: String,
    borderRadius: String
  },
  computed: {
    styleByVariant() {
      const styles = {
        outline: {
          borderColor: "var(--colors-light-secondary-divider)"
        },
        flushed: {
          variant: "flushed",
          borderColor: "var(--colors-light-secondary-divider)",
          _focus: {
            borderColor: "var(--colors-light-secondary-divider)",
            boxShadow: "initial"
          }
        },
        filled: {
          variant: "filled",
          height: "57px",
          bg: "var(--colors-light-primary-light-gray)",
          color: "var(--colors-light-primary-gray1)",
          borderRadius: "8px",
          _placeholder: {
            fontSize: "16px",
            color: "var(--colors-light-primary-gray1)",
            fontWeight: 400
          },
          _focus: {
            borderColor: "none",
            boxShadow: "initial"
          }
        }
      };
      return styles[this.variant];
    }
  },
  methods: {
    handleIconRightPointerDown(event) {
      event.preventDefault();
      event.stopPropagation();

      this.iconRightClick(event);
    },
    handleIconRightClick(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  },
  render: function (createElement) {
    const iconRightEvents = this.triggerIconRightOnPress
      ? {
          pointerdown: this.handleIconRightPointerDown,
          click: this.handleIconRightClick
        }
      : {
          click: this.iconRightClick
        };

    return createElement(
      CPseudoBox,
      {
        attrs: {
          position: "relative",
          width: "100%"
        }
      },
      [
        this.iconLeft &&
          createElement(OmtIcons, {
            attrs: {
              name: this.iconLeft,
              position: "absolute",
              top: this.variant === "outline" ? "14px" : "18px",
              left: "16px",
              zIndex: 2,
              cursor: this.iconLeftClick ? "pointer" : "auto"
            },
            ...(this.iconLeftClick && {
              on: {
                click: this.iconLeftClick
              }
            })
          }),
        createElement(CInput, {
          on: { ...this.$listeners },
          attrs: {
            ...this.styleByVariant,
            ...this.$attrs,
            ...(this.iconLeft && {
              pl: "42px"
            }),
            ...(this.iconRight && {
              pr: "42px"
            }),
            size: "lg",
            zIndex: 0,
            color: "var(--colors-light-primary-gray1)",
            fontSize: this.fontSize ? this.fontSize : "14px",
            letterSpacing: this.letterSpacing ? this.letterSpacing : "",
            lineHeight: "19px",
            fontWeight: this.fontWeight ? this.fontWeight : "600",
            ...(this.borderRadius && {
              borderRadius: this.borderRadius
            }),
            _disabled: {
              opacity: 0.7
            }
          }
        }),
        this.iconRight &&
          createElement(OmtIcons, {
            attrs: {
              name: this.iconRight,
              color: this.iconRightColor,
              prefix: this.iconRightPrefix,
              position: "absolute",
              top: "14px",
              right: "16px",
              zIndex: 2,
              cursor: this.iconRightClick ? "pointer" : "auto"
            },
            ...(this.iconRightClick && {
              on: iconRightEvents
            })
          })
      ]
    );
  }
});
</script>
